// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectMessageBaseClass as DirectMessageBase } from '../DirectMessageBase';
export class DirectAlgorithmMessageBase extends DirectMessageBase {
    constructor() {
        super(...arguments);
        this.AlgorithmId = -1;
    }
}
